import { create } from 'zustand';
import { authAPI } from '../services/api';

const useOrgStore = create((set, get) => ({
  organizations: JSON.parse(localStorage.getItem('organizations') || '[]'),
  currentOrg: JSON.parse(localStorage.getItem('current_org') || 'null'),
  isLoading: false,

  /**
   * Called after login: set the full list of accessible orgs.
   */
  setOrganizations: (orgs) => {
    localStorage.setItem('organizations', JSON.stringify(orgs));
    set({ organizations: orgs });
  },

  /**
   * Set the active org (used on login and after switch).
   */
  setCurrentOrg: (org) => {
    localStorage.setItem('current_org', JSON.stringify(org));
    set({ currentOrg: org });
  },

  /**
   * Switch to a different org. Calls POST /auth/switch-org,
   * updates token, clears React Query cache, triggers page reload.
   */
  switchOrg: async (orgId) => {
    const { organizations, currentOrg } = get();
    if (currentOrg?.id === orgId) return { success: true }; // already on this org

    set({ isLoading: true });
    try {
      const response = await authAPI.switchOrg({ org_id: orgId });
      const { token, refresh_token, current_org } = response;

      // Update auth token
      localStorage.setItem('auth_token', token);
      if (refresh_token) {
        localStorage.setItem('refresh_token', refresh_token);
      }

      // Update current org
      localStorage.setItem('current_org', JSON.stringify(current_org));
      set({ currentOrg: current_org, isLoading: false });

      // Clear React Query cache to avoid stale data from previous org
      // We use a global event that the app can listen to
      window.dispatchEvent(new CustomEvent('org-switched', { detail: { orgId, org: current_org } }));

      return { success: true };
    } catch (error) {
      set({ isLoading: false });
      return { success: false, error: error.message };
    }
  },

  /**
   * Clear all org state (called on logout).
   */
  clearOrg: () => {
    localStorage.removeItem('organizations');
    localStorage.removeItem('current_org');
    set({ organizations: [], currentOrg: null });
  },
}));

export default useOrgStore;
